<template>
    <div class="contact">
      <img src="../assets/logo.svg" alt="logo" class="contact-image">
      <div class="contact-form">

        <div class="contact-form__wrapper">
          <div class="contact-form__wrapper__field" :class="{'input--filled': userData.first_name.length > 0}">
            <input id="first_name" type="text" name="first_name" v-model="userData.first_name">
            <label for="first_name" :class="{ invalid: invalidName }"><span>Name*</span></label>
          </div>
          <div class="contact-form__wrapper__field" :class="{'input--filled': userData.last_name.length > 0}">
            <input id="last_name" type="text" name="last_name" v-model="userData.last_name">
            <label for="last_name" :class="{ invalid: invalidLastName }"><span>Last Name*</span></label>
          </div>
        </div>

        <div class="contact-form__wrapper">
          <div class="contact-form__wrapper__field" :class="{'input--filled': userData.address.length > 0}">
            <input id="address_name" type="text" name="address_name" v-model="userData.address">
            <label for="address_name"><span>Address</span></label>
          </div>
        </div>

        <div class="contact-form__wrapper">
          <div class="contact-form__wrapper__field" :class="{'input--filled': userData.city.length > 0}">
            <input id="city_name" type="email" name="email_name" v-model="userData.city">
            <label for="city_name"><span>City</span></label>
          </div>
          <div class="contact-form-block">
              <div class="contact-form__wrapper__field" style="flex-basis: 50%; margin-left: 0" :class="{'input--filled': userData.state.length > 0}">
                  <input id="state_name" type="text" name="phone_name" v-model="userData.state">
                  <label for="state_name"><span>State</span></label>
              </div>
              <div class="contact-form__wrapper__field" style="flex-basis: 50%; margin-right: 0" :class="{'input--filled': userData.zip.length > 0}">
                  <input id="zip_name" type="text" name="phone_name" v-model="userData.zip">
                  <label for="zip_name"><span>Zip</span></label>
              </div>
          </div>
        </div>

        <div class="contact-form__wrapper">
          <div class="contact-form__wrapper__field" :class="{'input--filled': userData.email.length > 0}">
            <input id="email_name" type="email" name="email_name" v-model="userData.email">
            <label for="email_name" :class="{ invalid: invalidEmail }"><span>Email*</span></label>
          </div>
          <div class="contact-form__wrapper__field" :class="{'input--filled': userData.phone.length > 0}">
            <input id="phone_name" type="text" name="phone_name" v-model="userData.phone">
            <label for="phone_name"><span>Phone</span></label>
          </div>
        </div>

        <div class="contact-form__wrapper question">
          <div class="contact-form__wrapper__question">
            <span>Are you a broker?</span>
            <div class="broker">
              <input id="broker_yes" type="radio" name="broker_yes" :checked="firstInputChecked">
              <label for="broker_yes" @click="checkInput('first')">Yes</label>
            </div>
            <div class="broker">
              <input id="broker_no" type="radio" name="broker" :checked="lastInputChecked">
              <label for="broker_no" @click="checkInput('last')">No</label>
            </div>
          </div>
          <transition name="fade">
              <div class="contact-form__wrapper__field" :class="{'input--filled': userData.brokerage_company.length > 0}" v-show="showBroker">
                <input id="brokerage_company" type="text" name="brokerage_company" v-model="userData.brokerage_company">
                <label for="brokerage_company"><span>Brokerage company</span></label>
              </div>
          </transition>
        </div>

        <button class="btn-submit" @click.prevent="submitForm">Submit</button>

        <div class="form-content">
          <div class="form-content__headline">
            <img src="../assets/de-logo.svg" alt="logo" class="form-content__headline--logo">
            <span class="form-content__headline--title">Sahar Ziv and Tavivian Team</span>
            <p class="form-content__headline--body">
                Equal Housing Opportunity. Any artist or computer renderings of the property,
                Building, units, amenities, interior/exterior decorations, finishes, fixtures, appliances, furnishings, and landscaping
                are provided for illustrative purposes only and reflect the planned scale and spirit of the Building.
                Sponsor makes no representations, guarantees, or warranties except as may be set forth in the Offering Plan.
                The complete offering terms are in the Offering Plan available from Sponsor.
                File No. CD19-0318. Sponsor: Avenue Second Owner, LLC, 41 Wooster Street, 2nd Floor, New York, NY 10013.
            </p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
      name: "Contact",
      data: () => ({
        userData: {
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          address: '',
          city: '',
          state: '',
          zip: '',
          brokerage_company: ''
        },
        showBroker: false,
        firstInputChecked: false,
        lastInputChecked: false,
        loading: false,
        invalidEmail: false,
        invalidName: false,
        invalidLastName: false
      }),
      watch: {
          userData: {
              handler: 'checkValue',
              immediate: false,
              deep: true
          }
      },
      methods: {
        checkValue () {
            if (this.userData.first_name.length) {
                this.invalidName = false
            }
            if (this.userData.last_name.length) {
                this.invalidLastName = false
            }
            if (this.userData.email.length) {
                this.invalidEmail = false
            }
        },
        submitForm() {
          this.invalidName = false
          this.invalidLastName = false
          this.invalidEmail = false

          if (this.loading) return;

          this.loading = true;
          if (!this.userData.first_name.length) {
              this.invalidName = true
          }
          if (!this.userData.first_name.length) {
              this.invalidLastName = true
          }
          if (!this.userData.email) {
              this.invalidEmail = true
          }

          if (this.invalidEmail || this.invalidLastName || this.invalidName) {
              return
          }

          fetch('/registrations-28sj2yskwi', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(this.userData)
          })
          .then(response => response.json())
          .finally(() => {
              this.loading = false;
              this.userData.first_name = '';
              this.userData.last_name = '';
              this.userData.email = '';
              this.userData.phone = '';
              this.userData.address = '';
              this.userData.city = '';
              this.userData.state = '';
              this.userData.zip = '';
              this.userData.brokerage_company = '';
              this.showBroker = false;
              this.firstInputChecked =false;
              this.lastInputChecked = false;
              this.hideLayers()
              if (this.$route.name.includes('contact')) {
                  this.$router.push({ path: '/' })
              }
          });
        },

        checkInput(value) {
          if(value === 'first') {
            this.firstInputChecked = true
            this.lastInputChecked = false
            this.showBroker = true
          } else {
            this.firstInputChecked = false
            this.lastInputChecked = true
            this.showBroker = false
          }
        },
        hideLayers() {
          this.$emit('hideLayers', true)
        }
      }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
